<template>
  <div id="user-page" class="container-fluid">
    <div class="alert alert-danger alert-margin" role="alert" v-if="isMessage">
      {{ message }}
    </div>
    <div id="title" class="row">
      <div class="col-1">
        <svg id="header" class="bd-placeholder-img mr-2 rounded" width="28" height="28" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid slice" focusable="false" role="img" aria-label="Placeholder: 32x32">
        <rect width="100%" height="100%" fill="#00C3E0"></rect>
        </svg>
      </div>
      <div class="col-5">
        <h5>連絡先変更</h5>
      </div>
      <div class="col-3">
        <button id="backBtn" type="button" class="btn-sm btn-outline-info btn_right" v-on:click="back">キャンセルする</button>
        <button id="destroyBtn" type="button" class="btn-sm btn-outline-danger btn_right" v-on:click="destroy">削除する</button>
      </div>
    </div>
    <div id="register_form" class="row">
      <div class="col-1">
      </div>
      <div class="col-8">
        <form @submit.prevent="modify">
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>連絡先名称</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="40" v-show="isDirectDefine" v-model="contact.contactName" class="form-control" autocomplete="off" placeholder="連絡先名（必須）" :required="isDirectDefine">
                <div v-show="isUserRef">{{contact.user.userName}}</div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
                <label>ふりがな</label>
              </div>
              <div class="col-9">
                <input type="text" maxlength="80" v-show="isDirectDefine" v-model="contact.contactKana" class="form-control" autocomplete="off" placeholder="ふりがな（必須）" :required="isDirectDefine">
                <div v-show="isUserRef">{{contact.user.userKana}}</div>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="isUserRef">
            <div class="row">
              <div class="col-3">
                <label>所属 (組織)</label>
              </div>
              <div class="col-9">
                <div>{{ setDisplayName(contact) }}</div>
              </div>
            </div>
          </div>
          <div class="form-group" v-for="(phoneNumber, index) in phoneNumbers" v-bind:key="`phoneNumber-${index}`" v-show="isDirectDefine">
            <div class="row">
              <div class="col-3">
                <label>番号{{ index  + 1 }}</label>
              </div>
              <div class="col-2">
                <select v-model="phoneNumber.type" class="form-control">
                  <option value="1" selected>内線</option>
                  <option value="2">外線</option>
                  <option value="3">ダイヤルイン</option>
                  <option value="4">FAX</option>
                </select>
              </div>
              <div class="col-6">
                <input type="text" maxlength="16" v-model="phoneNumber.phoneNumber" class="form-control" placeholder="番号（必須）" required>
              </div>
              <div class="col-1">
                <button type="button" class="btn-sm btn-outline-info" v-on:click="remove(index)" v-show="index !== 0">×</button>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="isDirectDefine">
            <div class="row">
              <div class="col-3">
              </div>
              <div class="col-9">
                <button type="button" class="btn-sm btn-outline-info" v-on:click="add" v-show="!isMaximum">番号を追加する</button>
              </div>
            </div>
          </div>
          <div class="form-group" v-show="isNichibyo && isUserRef">
            <div class="row">
              <div class="col-3">
                <label>個人貸与 内線番号</label>
              </div>
              <div class="col-6">
                <input type="text" maxlength="16" v-model="contact.extensionNumber" class="form-control" placeholder="番号">
              </div>
            </div>
          </div>
          <div class="form-group" v-for="(group, index) in groups" v-bind:key="`group-${index}`">
            <div class="row">
              <div class="col-3">
                <label>グループ{{ index  + 1 }}</label>
              </div>
              <div class="col-8">
                <select v-if="index==0" v-model="group.groupId" class="form-control" :required="required ? true : false">
                  <option v-for="option in groupOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.groupName }}
                  </option>
                </select>
                <select v-else v-model="group.groupId" class="form-control" required>
                  <option v-for="option in groupOptions" v-bind:value="option.id" v-bind:key="option.id">
                    {{ option.groupName }}
                  </option>
                </select>
              </div>
              <div class="col-1">
                <button type="button" class="btn-sm btn-outline-info" v-on:click="removeGroup(index)" v-show="index !== 0">×</button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <div class="col-3">
              </div>
              <div class="col-9">
                <button type="button" class="btn-sm btn-outline-info" v-on:click="addGroup" v-show="!isMaximumGroup">グループを追加する</button>
              </div>
            </div>
          </div>
          <button id="modify_button" type="submit" class="btn btn-info btn btn-block">更新する</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { sessions } from '../../mixin/session'
import { path } from '../../mixin/path'
import { headers } from '../../mixin/headers'

export default {
  name: 'Modify',
  mixins: [sessions,path,headers],
  props: ['realms','serviceName'],
  data: function(){
    return {
      name: 'group',
      message: '',
      contact: {
        type: '',
        contactName: '',
        contactKana: '',
        user: {
          userName: '',
          userKana: '',
          organization: {
            displayName: ''
          }
        },
        extensionNumber: ''
      },
      phoneNumbers: [
        {
          type: 1,
          phoneNumber: ''
        },
      ],
      groups: [],
      groupOptions: []
    }
  },
  computed: {
    isDirectDefine: function () {
      return this.contact.type === 'direct_define' || this.contact.type === 1
    },
    isUserRef: function () {
      return this.contact.type === 'user_ref' || this.contact.type === 2
    },
    isMessage: function () {
      return this.message.length > 0
    },
    isMaximum: function () {
      return this.phoneNumbers.length === 5
    },
    isMaximumGroup: function () {
      return this.groups.length === 3
    },
    required: function () {
      return this.groups.length > 1
    },
    isNichibyo: function () {
      return this.serviceName == 'Nichibyo'
    }
  },
  beforeMount() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var hospitalId = this.$store.getters.hospital.id
        var extraContactId = this.$route.params.extraContactId
        var url = this.$store.getters.contact.isHierarchyGroupEnabled 
                    ? "/api/hierarchygroup/management/hierarchylist" 
                    : "/api/group/management/public/list"
        axios
          .post(url, {
            hospitalId: hospitalId,
            extraContactId: extraContactId,
            hierarchyNo: 2
          },{
            headers: this.headers(accessToken)
          })
          .then(response => {
            this.groupOptions = response.data.data.groups
            this.groupOptions.unshift({
              id : '',
              groupName : ''
            })
          })
          .catch(err => {
            throw err
          })
        }
    }).catch((err) => {
      this.message = err.message
    })    
  },
  mounted() {
    this.$cognito.isAuthenticated().then((session) => {
      if(session){
        var accessToken = this.getAccessToken(this.$cognito,session)
        var contactId = this.$route.params.id;
        axios.get("/api/contact/management/public/" + contactId, {
            headers: this.headers(accessToken)
        }).then(response => {
          this.contact = response.data.data.contact;
          if (this.contact.user === null){
            this.contact.user = {
              userName: '',
              userKana: '',
              organization: {
                displayName: ''
              }
            }
          }
          this.phoneNumbers = response.data.data.phoneNumbers.map((element) => { 
            return {
              id: element.id,
              phoneNumber: element.phoneNumber,
              type: element.typeValue
            }
          })
          this.groups = response.data.data.groups;
          if(this.groups.length === 0){
            this.groups.push(
              {
                groupId: ''
              }
            )
          }
        }).catch(err => {
          this.message = err.message
        })
      }
    }).catch((err) => {
      this.message = err.message
    })
  },
  methods: {
    modify() {
      var checkGroups = this.groups.filter((element, index, self) => 
                            self.findIndex(e =>  e.groupId === element.groupId) === index)
      if (checkGroups.length !== this.groups.length){
        this.message =  'グループが重複しています'
        return
      } else {
        this.message = ''
      }
      this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var contactId = this.$route.params.id;
          this.contact.type = this.contact.type === 'direct_define' ? 1 : 2;
          if (this.contact.extensionNumber === "") this.contact.extensionNumber = null
          axios.put("/api/contact/management/public/" + contactId, {
              contact: this.contact,
              phoneNumbers: this.phoneNumbers,
              groups: this.groups
          },{
            headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('更新されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }
      }).catch((err) => {
          this.message = err.message
      })
    },
    back() {
      this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/index'))
    },
    setDisplayName(contact) {
      if (contact.user === null) return "";
      if (contact.user.organization === null) return "";
      if (contact.user.organization.displayName === null) return "";
      return contact.user.organization.displayName;
    },
    add() {
      this.phoneNumbers.push(
        {
          type: "1",
          phoneNumber: ''
        }
      )
    },
    remove(index) {
      this.phoneNumbers.splice(index, 1)
    },
    destroy() {
      if(confirm('削除してもよろしいですか?')){
        this.$cognito.isAuthenticated().then((session) => {
        if(session){
          var accessToken = this.getAccessToken(this.$cognito,session)
          var contactId = this.$route.params.id;
          axios.delete("/api/contact/management/public/" + contactId, {
              headers: this.headers(accessToken)
          }).then(response => {
            var res = response.data;
            if(res.errorMessage) {
              this.message = res.errorMessage
            } else {
              alert('削除されました。');
              this.$router.replace(this.replacePath(this.$cognito,this.realms,'/contacts/contact/index'))
            }
          }).catch(err => {
            this.message = err.message
          })
        }}).catch((err) => {
          this.message = err.message
        })
      }
    },
    addGroup() {
      this.groups.push(
        {
          groupId: ''
        }
      )
    },  
    removeGroup(index) {
      this.groups.splice(index, 1)
    }
  }
}
</script>

<style scoped>
#header {
  float: right;
}
#title {
  padding: 10px;
}
.btn_right {
  float:right;
}
#destroyBtn {
  margin-right: 10px;
}
#modify_button {
  margin-top: 30px;
}
.times-solid{
  cursor: pointer;
  height: 15px;
  width: 15px;
}
.form-table{
  margin-top: 5px;
}
.alert-margin{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>